// Base 9 diagnostic questions (12 questions across 5 spheres)
// Theme: Completion, compassion, humanitarianism, wisdom, letting go, universal love
const base9 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai sutinku žmogų, kuriam sunku ar kuris kenčia:',
      choices: {
        a: 'Nuoširdžiai užjaučiu ir padedu iš visos širdies, nejausdamas, kad privalau gauti ką nors mainais.',
        b: 'Taip giliai pasineriu į svetimą skausmą, kad pritrūkstu resursų sau, arba užsisklendžiu savyje, nes skausmo ir kančių aplink per daug.',
        c: 'Užjaučiu ir padedu, bet stengiuosi neperimti viso pasaulio skausmo ant savo pečių.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai gyvenime ateina metas kažką užbaigti ar paleisti:',
      choices: {
        a: 'Priimu pabaigas su ramybe ir dėkingumu, suprasdamas, kad jos atveria vietą naujam.',
        b: 'Įsikabinu į praeitį, ilgai dėl to išgyvenu ir negaliu paleisti to, kas jau pasibaigė.',
        c: 'Paleidžiu palaipsniui, kai įsitikinu, kad tikrai metas, bet iš pradžių dvejoju.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai galvoju apie pasaulį ir savo vietą jame:',
      choices: {
        a: 'Jaučiu ryšį su kažkuo didesniu už mane ir noriu palikti pasaulį šiek tiek geresnį.',
        b: 'Arba nusiviliu žmonėmis bei pasauliu, arba skęstu idealuose, atitrūkęs nuo realybės.',
        c: 'Rūpinuosi platesniais dalykais, bet pirmiausia stengiuosi susitvarkyti savo kasdienybę.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai renkuosi, kokiai veiklai skirti savo jėgas:',
      choices: {
        a: 'Renkuosi tai, kas turi prasmę ir padeda kitiems, nes prasmingas darbas mane įkvepia.',
        b: 'Arba aukojuosi dėl idėjos iki išsekimo, arba niekur nerandu pakankamai prasmės ir blaškausi.',
        c: 'Ieškau veiklos, kuri turi prasmę, bet ir leidžia patogiai pragyventi.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai darbe matau neteisybę arba kažką, kas, mano manymu, daroma neteisingai:',
      choices: {
        a: 'Ramiai, bet tvirtai stoju už tai, kuo tikiu, ir siekiu visiems teisingo sprendimo.',
        b: 'Įsiveliu į kovą taip, kad išsekinu save, arba nuleidžiu rankas manydamas, kad nieko nepakeisiu.',
        c: 'Pasisakau tik dėl tikrai svarbių dalykų, o smulkesnius praleidžiu pro šalį.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai artimuose santykiuose žmogus mane nuvilia ar įskaudina:',
      choices: {
        a: 'Stengiuosi suprasti, atleisti ir, jei verta, kurti ryšį toliau be senų nuoskaudų.',
        b: 'Arba ilgai nešuosi nuoskaudą ir kaltinu, arba viską nuryju ir kenčiu tylėdamas.',
        c: 'Atleidžiu, bet atsargiai, ir įsidėmiu pamoką ateičiai.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, ką reiškia mylėti žmogų:',
      choices: {
        a: 'Mylėti man reiškia priimti žmogų visą, su jo šviesa ir šešėliais, nemėginant jo perdaryti.',
        b: 'Arba idealizuoju partnerį ir nusiviliu, kai jis neatitinka, arba aukojuosi prarasdamas save.',
        c: 'Myliu nuoširdžiai, bet stengiuosi išlaikyti ir sveiką blaivumą bei savo ribas.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai turiu pinigų ir galvoju, kam juos skirti:',
      choices: {
        a: 'Mielai dalinuosi su tais, kuriems reikia, bet protingai pasirūpinu ir savimi.',
        b: 'Arba atiduodu viską kitiems ir lieku be nieko, arba jaučiuosi kaltas net dėl to, ką turiu.',
        c: 'Padedu kitiems tada, kai pats jaučiuosi finansiškai saugus ir stabilus.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai galvoju apie pinigus ir gyvenimo prasmę:',
      choices: {
        a: 'Pinigus matau kaip priemonę daryti gera, o ne kaip pagrindinį gyvenimo tikslą.',
        b: 'Arba laikau pinigus „nešvariais" ir jų vengiu, arba nerimauju, kad jų niekada neužteks geriems darbams.',
        c: 'Ieškau pusiausvyros tarp prasmingo dalijimosi ir realaus finansinio saugumo.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai jaučiu, kad gyvenime trūksta gilesnės prasmės:',
      choices: {
        a: 'Ieškau būdų daryti gera, kurti ir padėti, nes dalindamasis savo šiluma ir gerumu su aplinkiniais, aš jaučiu vidinę pilnatvę.',
        b: 'Pasineriu į liūdesį dėl pasaulio netobulumo arba bėgu nuo realybės į svajones.',
        c: 'Po truputį ieškau prasmės kasdieniuose dalykuose, neapsikraudamas viso pasaulio rūpesčiais.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo gyvenimo misiją ar didesnį tikslą:',
      choices: {
        a: 'Jaučiu, kad mano esmė yra mylėti, kurti ir skleisti pasaulyje šviesą.',
        b: 'Arba slegia jausmas, kad turėčiau „išgelbėti pasaulį", arba visai nebematau jokio tikslo.',
        c: 'Tikiu, kad turiu prasmę, bet ją atrandu pamažu, gyvendamas paprastą kasdienybę.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas pateikia didelį praradimą ar skausmingą pabaigą:',
      choices: {
        a: 'Išgyvenu skausmą, bet randu jame gilesnę prasmę ir leidžiu jam mane subrandinti.',
        b: 'Arba ilgam paskęstu sielvarte, arba bandau visai nejausti ir atsiriboju nuo savęs.',
        c: 'Pergyvenu netektį palaipsniui ir pamažu vėl atrandu vidinę ramybę.',
      },
    },
  ];

export default base9;
